<template>
  <v-row class="upsell-page">
    <!-- Config layout -->
    <MenuApps :menu="menu" :defaultActiveMenu="defaultActiveMenu" />
    <v-col class="upsell-page-container">
      <div class="upsell-page-content">
        <router-view />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import MenuApps from '../components/MenuApps';

export default {
  components: {
    MenuApps,
  },
  data() {
    return {
      menu: [
        {
          title: 'Catalog',
          icon: 'fas fa-home',
          name: 'website.apps.print-hub.catalog',
        },
        {
          title: 'All campaigns',
          icon: 'fas fa-home',
          name: 'website.apps.print-hub.campaigns',
        },
        {
          title: 'Library',
          icon: 'fas fa-tags',
          name: 'website.apps.print-hub.artwork',
          children: [
            {
              title: 'Artworks',
              name: 'website.apps.print-hub.artwork',
            },
            // {
            //   title: 'Cliparts',
            //   name: 'website.apps.print-hub.cliparts',
            // },
          ],
        },
      ],
      defaultActiveMenu: 'website.apps.print-hub.catalog',
    };
  },
};
</script>
<style lang="scss">
.upsell-page {
  height: 100% !important;
  .upsell-page-container {
    @include flex(center, flex-center);
    overflow-y: auto;
    padding-left: 260px;
    & .upsell-page-content {
      max-width: 1280px;
      min-width: 700px;
      margin-top: 40px;
    }
  }
}
</style>
